import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { topicLinkTopic$key } from "~/queries/__generated__/topicLinkTopic.graphql";

import { StyledEntityLink } from "./styles";

export type Props = {
  className?: string;
  reference: topicLinkTopic$key;
};

export const TopicLink: FunctionComponent<Props> = ({ className, reference: reference_ }) => {
  const topic = useFragment(
    graphql`
      fragment topicLinkTopic on Topic {
        ...entityLink
        name
      }
    `,
    reference_,
  );

  return (
    <StyledEntityLink className={className} reference={topic}>
      {topic.name}
    </StyledEntityLink>
  );
};

TopicLink.displayName = "TopicLink";
